export enum SiteType {
  company,
  university,
  organisation,
  hospital
}
